import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31a96e96")

_pushScopeId("data-v-31a96e96")
const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_2 = {
  key: 1,
  class: "mt-4 mb-4 w-100 text-center"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-datatable-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Krav")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Værdi")
    ])
  ])
], -1)
const _hoisted_6 = { class: "value-claims" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "value-claims" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.hasUserProfile)
      ? (_openBlock(), _createBlock(_component_error, {
          key: 0,
          error: {
        title: 'Ingen administrative rettigheder',
        message:
          'Du er logget ind via Vejdirektoratets EntraID og er ikke tildelt nogen rettigheder.',
      }
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    (_ctx.payload)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (!_ctx.hasUserProfile)
            ? (_openBlock(), _createBlock("strong", _hoisted_3, "Udstedte claims fra EntraID"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("table", _hoisted_4, [
      _hoisted_5,
      _createVNode("tbody", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.payload, (value, key) => {
          return (_openBlock(), _createBlock(_Fragment, { key: key }, [
            (Array.isArray(value))
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(value, (item, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: `${key}-${index}`
                  }, [
                    _createVNode("td", null, _toDisplayString(key), 1),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_6, _toDisplayString(item), 1)
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createBlock("tr", _hoisted_7, [
                  _createVNode("td", null, _toDisplayString(key), 1),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_8, _toDisplayString(value), 1)
                  ])
                ]))
          ], 64))
        }), 128))
      ])
    ])
  ]))
})